module.exports = __webpack_public_path__ + "static/media/ts.c237b6ce.png";